import React, { ChangeEvent, useState, useEffect } from 'react';
import { Table, Row, Col } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { CSVLink } from 'react-csv';

import './styles.css'


//SERVICES
import { getOsFromUser } from '../../services/OsService';

import useWindowDimensions from '../../helpers/GetCurrentWidth';

export default function TableOsDetalhado() {

  const { width } = useWindowDimensions();
  const [data, setData] = useState<any[]>([]);
  const [dataExport, setDataExport] = useState<any[]>([]);
  const [qtySelected, setQtySelected] = useState<number>(0);
  const [search, setSearch] = useState<string>('');
  const [role, setRole] = useState<string>('user');
  const [pageCounts, setPageCounts] = useState<any>(1);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [displayPerPage, setDisplayPerPage] = useState<number>(5);

  const HeaderList = [
    'SINDICANCIA',
    'SEGURADORA',
    'TIPO SINDICANCIA',
    'SINISTRO',
    'VISTORIA',
    'SEGURADO',
    'RELATO CROQUI',
    'NATUREZA',
    'VEICULO',
    'PLACA',
    'NOME PRESTADOR',
    'BEMSEGURADO',
    'INDENIZACAO',
    'ENDERECO',
    'PRIORIDADE',
    'RESULTADO',
    'CAUSA',
    'REGULARIDADE',
    'CONCLUSAO',
    'VALORPROGRESSO',
    'DATA ABERTURA',
    'DATA ULTIMA ALTERACAO',
    'DISTANCIA',
    'DURAÇÃO TRAJETO',
    'ENDEREÇO INICIAL',
    'ENDEREÇO FINAL',
    'VIA',
    'IML',
    'MAO',
    'SINALIZACAO',
    'CANTEIRO',
    'ILUMINACAO',
    'LOCAL',
    'RELATO ORGAOS',
    'DPTO POLICIA',
    'OCORRENCIA',
    'BOMBEIROS',
    'CONCESSIONARIA',
    'HOSPITAL',
    'REDES SOCIAIS',
    'PROFISSAO SEGURADO',
    'LOCALP ERNOITE',
    'UNICO CONDUTOR',
    'RESID IDADE',
    'RESID IDADE VEICULO',
    'CONDUTOR PRINCIPAL',
    'POSSUI CADASTRO APLICATIVO',
    'CADASTRO APLICATIVO',
    'HAVIA PASSAGEIRO',
    'ENDOSSO PARTICULAR COMERCIAL',
    'ENDOSSO ANTES DEPOIS',
    'EXTRATO CORRIDA',
    'MEDIA KM DIA SEMANA',
    'KMATUAL',
    'SEG CONVIVIO COMERCIAL',
    'SEG CONVIVIO COMERCIAL RELATO',
    'SEG CONVIVIO RESIDENCIAL',
    'SEG CONVIVIO RESIDENCIAL RELATO',
    'LISTARTERCEIROS',
    'TER CONVIVIO COMERCIAL',
    'TER CONVIVIO COMERCIAL RELATO',
    'TER CONVIVIO RESIDENCIAL',
    'TER CONVIVIO RESIDENCIAL RELATO',
    'TRANSCRICAOENTREVISTA',
    'NOTA',
    'FINALIZADO',
    'PAVIMENTACAO',
    'TIPO TRECHO',
    'NIVEL',
    'ACOSTAMENTO',
    'PERMISSAO ESTACIONAR',
    'TESTEMUNHAS',
    'MONITORAMENTO',
    'VIGILANCIA',
    'AREA',
    'SEG CONVIVIO COMERCIAL CPF',
    'NUMEROOCORRENCIA',
    'SEG CONVIVIO COMERCIAL NOME',
    'SEG CONVIVIO COMERCIAL UF',
    'SEG CONVIVIO COMERCIAL CIDADE',
    'SEG CONVIVIO RESIDENCIAL CPF',
    'SEG CONVIVIO RESIDENCIAL NOME',
    'SEG CONVIVIO RESIDENCIAL UF',
    'SEG CONVIVIO RESIDENCIAL CIDADE',
    'TER CONVIVIO COMERCIAL CPF',
    'TER CONVIVIO COMERCIAL NOME',
    'TER CONVIVIO COMERCIAL UF',
    'TER CONVIVIO COMERCIAL CIDADE',
    'TER CONVIVIO RESIDENCIAL CPF',
    'TER CONVIVIO RESIDENCIAL NOME',
    'TER CONVIVIO RESIDENCIAL UF',
    'TER CONVIVIO RESIDENCIAL CIDADE',
    'LOCAL SINISTRO',
    'FEEDBACK',
    'ANALISTA SINISTRO',
    'DATA AREA SINDICANCIA',

  ]


  useEffect(() => {
    getData();
  }, [])


  const getData = () => {
    getOsFromUser().then(async (res) => {
      const response = res?.data?.rows

      const newUser: any = localStorage.getItem('user');
      const newUserJson = JSON.parse(newUser);
      await setRole(newUserJson.role);

      setDisplayPerPage(100);
      setData(response);
      const countPage = response && (response.length / displayPerPage).toFixed();
      setPageCounts(Number(countPage) > 0 ? countPage : 1)
      setFilteredData(response)
    })
      .catch(err => { })
  }

  // filtra de acordo com pesquisa
  const filterList = (event: ChangeEvent<HTMLFormElement>) => {
    const { value } = event.target;
    setSearch(value);

    const newList = data?.filter((item) => JSON.stringify(item).toLowerCase().indexOf(value.toLowerCase()) !== -1);

    setFilteredData(newList)

  }

  // captura dados para exportação ao clicar no input checkbox
  const handleCheck = async (index: number) => {
    const newData = filteredData;

    if (newData) newData[index].checked = !newData[index].checked;
    const dataFilteredCheck = newData?.filter(i => i.checked);
    const qty = dataFilteredCheck ? dataFilteredCheck.length : 0;

    setQtySelected(qty)
    setFilteredData(newData)
    const formattedData = await formatData(dataFilteredCheck)


    setDataExport(formattedData)
  }

  // formada dados para arquivo de extração
  const formatData = async (data: any) => {
    return await data.map((i: any) => {
      return {
        'SINDICANCIA': escapeCsv(i.sindicancia),
        'SEGURADORA': escapeCsv(i.seguradora),
        'TIPO SINDICANCIA': escapeCsv(i.tipoSindicancia),
        'SINISTRO': escapeCsv(i.sinistro),
        'VISTORIA': escapeCsv(i.vistoria),
        'SEGURADO': escapeCsv(i.segurado),
        'RELATO CROQUI': escapeCsv(i.relatoCroqui),
        'NATUREZA': escapeCsv(i.natureza),
        'VEICULO': escapeCsv(i.veiculo),
        'PLACA': escapeCsv(i.placa),
        'NOME PRESTADOR': escapeCsv(i.prestador?.name),
        'BEMSEGURADO': escapeCsv(i.bemSegurado),
        'INDENIZACAO': escapeCsv(i.indenizacao),
        'ENDERECO': escapeCsv(i.endereco),
        'PRIORIDADE': escapeCsv(i.prioridade),
        'RESULTADO': escapeCsv(i.resultado),
        'CAUSA': escapeCsv(i.causa),
        'REGULARIDADE': escapeCsv(i.regularidade),
        'CONCLUSAO': escapeCsv(i.conclusao),
        'VALORPROGRESSO': escapeCsv(i.valorProgresso),
        'DATA ABERTURA': escapeCsv(i.createdAt),
        'DATA ULTIMA ALTERACAO': escapeCsv(i.updatedAt),
        'DISTANCIA': escapeCsv(i.distance),
        'DURAÇÃO TRAJETO': escapeCsv(i.duration),
        'ENDEREÇO INICIAL': escapeCsv(i.start_address),
        'ENDEREÇO FINAL': escapeCsv(i.end_address),
        'VIA': escapeCsv(i.via),
        'IML': escapeCsv(i.iml),
        'MAO': escapeCsv(i.mao),
        'SINALIZACAO': escapeCsv(i.sinalizacao),
        'CANTEIRO': escapeCsv(i.canteiro),
        'ILUMINACAO': escapeCsv(i.iluminacao),
        'LOCAL': escapeCsv(i.local),
        'RELATO ORGAOS': escapeCsv(i.relatoOrgaos),
        'DPTO POLICIA': escapeCsv(i.dptoPolicia),
        'OCORRENCIA': escapeCsv(i.ocorrencia),
        'BOMBEIROS': escapeCsv(i.bombeiros),
        'CONCESSIONARIA': escapeCsv(i.concessionaria),
        'HOSPITAL': escapeCsv(i.hospital),
        'REDES SOCIAIS': escapeCsv(i.redesSociais?.relato),
        'PROFISSAO SEGURADO': escapeCsv(i.profissaoSegurado),
        'LOCALP ERNOITE': escapeCsv(i.localPernoite),
        'UNICO CONDUTOR': escapeCsv(i.unicoCondutor),
        'RESID IDADE': escapeCsv(i.residIdade),
        'RESID IDADE VEICULO': escapeCsv(i.residIdadeVeiculo),
        'CONDUTOR PRINCIPAL': escapeCsv(i.condutorPrincipal),
        'POSSUI CADASTRO APLICATIVO': escapeCsv(i.possuiCadastroAplicativo),
        'CADASTRO APLICATIVO': escapeCsv(i.cadastroAplicativo),
        'HAVIA PASSAGEIRO': escapeCsv(i.haviaPassageiro),
        'ENDOSSO PARTICULAR COMERCIAL': escapeCsv(i.endossoParticularComercial),
        'ENDOSSO ANTES DEPOIS': escapeCsv(i.endossoAntesDepois),
        'EXTRATO CORRIDA': escapeCsv(i.extratoCorrida),
        'MEDIA KM DIA SEMANA': escapeCsv(i.mediaKmDiaSemana),
        'KMATUAL': escapeCsv(i.kmAtual),
        'SEG CONVIVIO COMERCIAL': escapeCsv(i.segConvivioComercial),
        'SEG CONVIVIO COMERCIAL RELATO': escapeCsv(i.segConvivioComercialRel),
        'SEG CONVIVIO RESIDENCIAL': escapeCsv(i.segConvivioResidencial),
        'SEG CONVIVIO RESIDENCIAL RELATO': escapeCsv(i.segConvivioResidencialRel),
        'LISTARTERCEIROS': escapeCsv(i.listarTerceiros),
        'TER CONVIVIO COMERCIAL': escapeCsv(i.terConvivioComercial),
        'TER CONVIVIO COMERCIAL RELATO': escapeCsv(i.terConvivioComercialRel),
        'TER CONVIVIO RESIDENCIAL': escapeCsv(i.terConvivioResidencial),
        'TER CONVIVIO RESIDENCIAL RELATO': escapeCsv(i.terConvivioResidencialRel),
        'TRANSCRICAOENTREVISTA': escapeCsv(i.transcricaoEntrevista),
        'NOTA': escapeCsv(i.nota),
        'FINALIZADO': escapeCsv(i.finalizado),
        'PAVIMENTACAO': escapeCsv(i.pavimentacao),
        'TIPO TRECHO': escapeCsv(i.tipoTrecho),
        'NIVEL': escapeCsv(i.nivel),
        'ACOSTAMENTO': escapeCsv(i.acostamento),
        'PERMISSAO ESTACIONAR': escapeCsv(i.permissaoEstacionar),
        'TESTEMUNHAS': escapeCsv(i.testemunhas),
        'MONITORAMENTO': escapeCsv(i.monitoramento),
        'VIGILANCIA': escapeCsv(i.vigilancia),
        'AREA': escapeCsv(i.area),
        'SEG CONVIVIO COMERCIAL CPF': escapeCsv(i.segConvivioComercialCPF),
        'NUMEROOCORRENCIA': escapeCsv(i.numeroOcorrencia),
        'SEG CONVIVIO COMERCIAL NOME': escapeCsv(i.segConvivioComercialNome),
        'SEG CONVIVIO COMERCIAL UF': escapeCsv(i.segConvivioComercialUF),
        'SEG CONVIVIO COMERCIAL CIDADE': escapeCsv(i.segConvivioComercialCidade),
        'SEG CONVIVIO RESIDENCIAL CPF': escapeCsv(i.segConvivioResidencialCPF),
        'SEG CONVIVIO RESIDENCIAL NOME': escapeCsv(i.segConvivioResidencialNome),
        'SEG CONVIVIO RESIDENCIAL UF': escapeCsv(i.segConvivioResidencialUF),
        'SEG CONVIVIO RESIDENCIAL CIDADE': escapeCsv(i.segConvivioResidencialCidade),
        'TER CONVIVIO COMERCIAL CPF': escapeCsv(i.terConvivioComercialCPF),
        'TER CONVIVIO COMERCIAL NOME': escapeCsv(i.terConvivioComercialNome),
        'TER CONVIVIO COMERCIAL UF': escapeCsv(i.terConvivioComercialUF),
        'TER CONVIVIO COMERCIAL CIDADE': escapeCsv(i.terConvivioComercialCidade),
        'TER CONVIVIO RESIDENCIAL CPF': escapeCsv(i.terConvivioResidencialCPF),
        'TER CONVIVIO RESIDENCIAL NOME': escapeCsv(i.terConvivioResidencialNome),
        'TER CONVIVIO RESIDENCIAL UF': escapeCsv(i.terConvivioResidencialUF),
        'TER CONVIVIO RESIDENCIAL CIDADE': escapeCsv(i.terConvivioResidencialCidade),
        'LOCAL SINISTRO': escapeCsv(i.localSinistro),
        'FEEDBACK': escapeCsv(i.feedback),
        'ANALISTA SINISTRO': escapeCsv(i.analistaSinistro),
        'DATA AREA SINDICANCIA': escapeCsv(i.dateAreaSindicancia),
      }
    })
  }

  // Função para escapar valores para CSV
  const escapeCsv = (value: any) => {
    if (value === null || value === undefined) return '';
    let str = value.toString();
    // Se contiver vírgula ou aspas, adicionar aspas e escapar as aspas internas
    if (str.includes(',') || str.includes('"')) {
      str = `"${str.replace(/"/g, '""')}"`; // Substitui as aspas internas por duas aspas
    }
    return str;
  };



  return (

    <div className="container-box d-block position-relative mt-3 ">
      <div className={width < 768 ? 'd-flex justify-content-center w-100' : 'table-toolbar mb-1'}>
        <Row className={width < 768 ? 'w-100 mt-3' : 'w-100'}>
          <Col xs={12} sm={5} md={5} lg={4} className={width < 768 ? '' : 'd-flex justify-content-between align-items-center'}>
            <div className={`d-flex justify-content-center align-items-center my-os`}>
              <span className="ms-3">Processos Detalhados</span>
            </div>
          </Col>
          <Col xs={12} sm={7} md={7} lg={8} className={width < 768 ? 'mt-4' : 'd-flex justify-content-end align-items-center'}>

            <div className="d-flex justify-content-center align-items-center tools ">

              <span className={width < 768 ? 'd-none' : 'me-3'}>
                {`${qtySelected} Selecionado`}
              </span>
              <CSVLink
                filename={`export_sindicante_digital.csv`}
                data={dataExport}
                separator={';'}
                className={'btn-primary-outline color-black me-5 export-data'}
              >
                Exportar
              </CSVLink>
              <div className="filter-os">
                <FaSearch className="fa-search"></FaSearch>
                <input type="text" placeholder="Pesquisar" value={search}
                  onChange={(event: any) => filterList(event)}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="overflow-x-scroll">
        <Table className="data-table">
          <thead>
            <tr className="table-header">
              <th>
                {/* <input type="checkbox" name="checkbox_all" id="checkbox_all" onClick={(event: any) => selectAll(event.target.checked)} />*/}
              </th>
              {
                HeaderList && HeaderList.map((header, index) => {
                  return <th key={index} className="text-center header-th">{header}</th>
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              filteredData.map((data, index) => {
                return <>
                  <tr key={index} className="text-center">
                    <td className="max-width-unset">
                      <div>
                        <input type="checkbox" name={data.id} checked={data.checked} onClick={() => handleCheck(index)} />
                      </div>
                    </td>
                    <td><div>{data.sindicancia}</div></td>
                    <td><div>{data.seguradora}</div></td>
                    <td><div>{data.tipoSindicancia}</div></td>
                    <td><div>{data.sinistro}</div></td>
                    <td><div>{data.vistoria}</div></td>
                    <td><div>{data.segurado}</div></td>
                    <td><div>{data.relatoCroqui}</div></td>
                    <td><div>{data.natureza}</div></td>
                    <td><div>{data.veiculo}</div></td>
                    <td><div>{data.placa}</div></td>
                    <td><div>{data.prestador && data.prestador.name}</div></td>
                    <td><div>{data.bemSegurado}</div></td>
                    <td><div>{data.indenizacao}</div></td>
                    <td><div>{data.endereco}</div></td>
                    <td><div>{data.prioridade}</div></td>
                    <td><div>{data.resultado}</div></td>
                    <td><div>{data.causa}</div></td>
                    <td><div>{data.regularidade}</div></td>
                    <td><div>{data.conclusao}</div></td>
                    <td><div>{data.valorProgresso}</div></td>
                    <td><div>{data.createdAt.split('T')[0]}</div></td>
                    <td><div>{data.updatedAt}</div></td>
                    <td><div>{data.distance}</div></td>
                    <td><div>{data.duration}</div></td>
                    <td><div>{data.start_address}</div></td>
                    <td><div>{data.end_address}</div></td>
                    <td><div>{data.via}</div></td>
                    <td><div>{data.iml}</div></td>
                    <td><div>{data.mao}</div></td>
                    <td><div>{data.sinalizacao}</div></td>
                    <td><div>{data.canteiro}</div></td>
                    <td><div>{data.iluminacao}</div></td>
                    <td><div>{data.local}</div></td>
                    <td><div>{data.relatoOrgaos}</div></td>
                    <td><div>{data.dptoPolicia}</div></td>
                    <td><div>{data.ocorrencia}</div></td>
                    <td><div>{data.bombeiros}</div></td>
                    <td><div>{data.concessionaria}</div></td>
                    <td><div>{data.hospital}</div></td>
                    <td><div>{data.redesSociais?.relato}</div></td>
                    <td><div>{data.profissaoSegurado}</div></td>
                    <td><div>{data.localPernoite}</div></td>
                    <td><div>{data.unicoCondutor}</div></td>
                    <td><div>{data.residIdade}</div></td>
                    <td><div>{data.residIdadeVeiculo}</div></td>
                    <td><div>{data.condutorPrincipal}</div></td>
                    <td><div>{data.possuiCadastroAplicativo}</div></td>
                    <td><div>{data.cadastroAplicativo}</div></td>
                    <td><div>{data.haviaPassageiro}</div></td>
                    <td><div>{data.endossoParticularComercial}</div></td>
                    <td><div>{data.endossoAntesDepois}</div></td>
                    <td><div>{data.extratoCorrida}</div></td>
                    <td><div>{data.mediaKmDiaSemana}</div></td>
                    <td><div>{data.kmAtual}</div></td>
                    <td><div>{data.segConvivioComercial}</div></td>
                    <td><div>{data.segConvivioComercialRel}</div></td>
                    <td><div>{data.segConvivioResidencial}</div></td>
                    <td><div>{data.segConvivioResidencialRel}</div></td>
                    <td><div>{data.listarTerceiros}</div></td>
                    <td><div>{data.terConvivioComercial}</div></td>
                    <td><div>{data.terConvivioComercialRel}</div></td>
                    <td><div>{data.terConvivioResidencial}</div></td>
                    <td><div>{data.terConvivioResidencialRel}</div></td>
                    <td><div>{data.transcricaoEntrevista}</div></td>
                    <td><div>{data.nota}</div></td>
                    <td><div>{data.finalizado}</div></td>
                    <td><div>{data.pavimentacao}</div></td>
                    <td><div>{data.tipoTrecho}</div></td>
                    <td><div>{data.nivel}</div></td>
                    <td><div>{data.acostamento}</div></td>
                    <td><div>{data.permissaoEstacionar}</div></td>
                    <td><div>{data.testemunhas}</div></td>
                    <td><div>{data.monitoramento}</div></td>
                    <td><div>{data.vigilancia}</div></td>
                    <td><div>{data.area}</div></td>
                    <td><div>{data.segConvivioComercialCPF}</div></td>
                    <td><div>{data.numeroOcorrencia}</div></td>
                    <td><div>{data.segConvivioComercialNome}</div></td>
                    <td><div>{data.segConvivioComercialUF}</div></td>
                    <td><div>{data.segConvivioComercialCidade}</div></td>
                    <td><div>{data.segConvivioResidencialCPF}</div></td>
                    <td><div>{data.segConvivioResidencialNome}</div></td>
                    <td><div>{data.segConvivioResidencialUF}</div></td>
                    <td><div>{data.segConvivioResidencialCidade}</div></td>
                    <td><div>{data.terConvivioComercialCPF}</div></td>
                    <td><div>{data.terConvivioComercialNome}</div></td>
                    <td><div>{data.terConvivioComercialUF}</div></td>
                    <td><div>{data.terConvivioComercialCidade}</div></td>
                    <td><div>{data.terConvivioResidencialCPF}</div></td>
                    <td><div>{data.terConvivioResidencialNome}</div></td>
                    <td><div>{data.terConvivioResidencialUF}</div></td>
                    <td><div>{data.terConvivioResidencialCidade}</div></td>
                    <td><div>{data.localSinistro}</div></td>
                    <td><div>{data.feedback}</div></td>
                    <td><div>{data.analistaSinistro}</div></td>
                    <td><div>{data.dateAreaSindicancia}</div></td>
                  </tr>
                </>
              })
            }
          </tbody>
        </Table>
      </div>

    </div >

  )
}
